import type { Method } from 'lib/axios';
import { APICallV1 } from 'reactApp/api/APICall';

export class ProfileAgreeLaApiCall extends APICallV1 {
    _method = 'profile/agree_la';
    _type: Method = 'post';
    defaultData = this._defaultPayload;
}
